/**
 * @generated SignedSource<<ddccfccab0f6f8819d3a6765788b8f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminTemplateCardPaginationFragment_templateFlows$data = {
  readonly flows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"TemplateFavorite_flow">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "AdminTemplateCardPaginationFragment_templateFlows";
};
export type AdminTemplateCardPaginationFragment_templateFlows$key = {
  readonly " $data"?: AdminTemplateCardPaginationFragment_templateFlows$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminTemplateCardPaginationFragment_templateFlows">;
};

import AdminTemplateCardTemplateFlowsPaginationQuery_graphql from './AdminTemplateCardTemplateFlowsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "flows"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "flowFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": AdminTemplateCardTemplateFlowsPaginationQuery_graphql
    }
  },
  "name": "AdminTemplateCardPaginationFragment_templateFlows",
  "selections": [
    {
      "alias": "flows",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "flowFilter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "FlowsConnection",
      "kind": "LinkedField",
      "name": "__AdminTemplateCard_flows_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Flow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "gwtUserId",
                      "variableName": "gwtUserId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "TemplateFavorite_flow"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "84e374a20ff11bf6dc1e5a890851344c";

export default node;
